import type { FunctionComponent } from 'react';

import { type ArtistT, P_ADMIN_PRACTITIONERS, getId } from 'utils';

import { UserLink } from '../UserLink';

import './style.scss';

type PropsT = {
  disabled?: boolean;
  practitioner: ArtistT;
};

/**
 * Renders a combination of the given practitioner's avatar and name,
 * which acts as a link to the practitioner profile page in CMS.
 */
const AdminPractitionerLink: FunctionComponent<PropsT> = ({
  disabled,
  practitioner,
}) => (
  <UserLink
    artistId={getId(practitioner)}
    disabled={disabled}
    to={`${P_ADMIN_PRACTITIONERS}/${getId(practitioner)}`}
    user={practitioner.user}
  />
);

export default AdminPractitionerLink;
